import { Box, Tab, Tabs, Typography } from '@mui/material';
import React, { useState, useEffect } from 'react';
import DialogMediaPlayer from '../../../../../DialogMediaPlayer/DialogMediaPlayer';
import usePractitionerControlsContext from '../../../../../../hooks/usePractitionerControlsContext/usePractitionerControlsContext';
import { ReactPlayerProps } from 'react-player';
import { ImageContentPanelStyle } from './ImageContentPanelStyle';
import DefaultImage from '../../../../../../assets/no_image.svg';
import { PLayerTriggeredBy } from '../../../../../../commands/practitioner/enums/PLayerTriggeredBy';

interface ImageContentPanelProps {
  className?: string;
  index: number;
  value: number;
}

const ImageContentPanel = (props: ImageContentPanelProps) => {
  const { index, value } = props;
  const { practitionerMediaURI, isMediaLoaded } = usePractitionerControlsContext();

  const { imageTabContainer } = ImageContentPanelStyle;
  const [isValidImage, setIsValidImage] = useState(false);

  // checks if url is broken. If yes, then we don't render player
  useEffect(() => {
    const checkImage = () => {
      const img = new Image();
      img.onload = () => {
        setIsValidImage(true);
      };
      img.onerror = () => {
        setIsValidImage(false);
      };
      img.src = practitionerMediaURI;
    };

    checkImage();
  }, [practitionerMediaURI]);

  const config = {
    youtube: {
      playerVars: {
        showinfo: 1,
        origin: window.location.origin,
      },
    },
  };

  const reactPlayerPreview: ReactPlayerProps = {
    url: practitionerMediaURI,
    width: '100%',
    height: '100%',
    config,
  };

  return (
    <Box
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      sx={imageTabContainer}
    >
      {value === index && (
        <>
          <Box className={'image-container'}>
            {!!practitionerMediaURI && isMediaLoaded ? (
              isValidImage ? (
                <DialogMediaPlayer
                  key={practitionerMediaURI}
                  ReactPlayerProps={reactPlayerPreview}
                  ReactPlayerTriggeredBy={PLayerTriggeredBy.Practitioner}
                />
              ) : (
                <Box className={'image-default'}>
                  <img src={DefaultImage} />
                </Box>
              )
            ) : (
              <Box className={'image-default'}>
                <img src={DefaultImage} />
              </Box>
            )}
          </Box>
        </>
      )}
    </Box>
  );
};

export default ImageContentPanel;
